import { clsx } from 'clsx';
import * as style from './styles.css';
import { Label, useDeviceType, UIText3 } from '@cian/ui-kit';

export const HelpFromPartners: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={style['title']}>Уже нашли для&nbsp;вас лучших в&nbsp;своём&nbsp;деле</div>
      <div className={style['our_actions']}>
        <div className={style['our_action']}>
          <div className={style['our_action_image_1']}></div>
          <div className={style['our_action_text']}>Определили лидеров рынка со&nbsp;стажем&nbsp;больше 5 лет</div>
        </div>
        <div className={style['our_action']}>
          <div className={style['our_action_image_2']}></div>
          <div className={style['our_action_text']}>Проверили документы агентов</div>
        </div>
        <div className={style['our_action']}>
          <div className={style['our_action_image_3']}></div>
          <div className={style['our_action_text']}>
            Выбрали&nbsp;профи&nbsp;с&nbsp;хорошей репутацией и&nbsp;отзывами
          </div>
        </div>
      </div>
      <div className={style['our_agents']}>
        <div className={style['agent']}>
          <div className={style['agent_image_1']}></div>
          <div className={style['agent_name']}>Анатолий</div>
          <div className={style['agent_chips']}>
            <div className={style['agent_chip_experience']}>
              <UIText3>
                <Label color="decorative-accent-purple" background="decorative-accent-lavender">
                  Стаж 16 лет
                </Label>
              </UIText3>
            </div>
            <div className={style['agent_chip_superagent']}>
              <Label color="accent-positive-primary" background="accent-positive-secondary">
                Суперагент
              </Label>
            </div>
          </div>
          <div className={style['agent_description']}>
            У меня огромный опыт сделок со&nbsp;вторичкой, люблю деловой подход и системность
          </div>
        </div>
        <div className={style['agent']}>
          <div className={style['agent_image_2']}></div>
          <div className={style['agent_name']}>Татьяна</div>
          <div className={style['agent_chips']}>
            <div className={style['agent_chip_experience']}>
              <Label color="decorative-accent-purple" background="decorative-accent-lavender">
                Стаж 7 лет
              </Label>
            </div>
            <div className={style['agent_chip_superagent']}>
              <Label color="accent-positive-primary" background="accent-positive-secondary">
                Суперагент
              </Label>
            </div>
          </div>
          <div className={style['agent_description']}>
            Я юрист по образованию, уделяю внимание мелочам и умею работать со&nbsp;сложными кейсами
          </div>
        </div>
        <div className={style['agent']}>
          <div className={style['agent_image_3']}></div>
          <div className={style['agent_name']}>Екатерина</div>
          <div className={style['agent_chips']}>
            <div className={style['agent_chip_experience']}>
              <Label color="decorative-accent-purple" background="decorative-accent-lavender">
                Стаж 5 лет
              </Label>
            </div>
            <div className={style['agent_chip_superagent']}>
              <Label color="accent-positive-primary" background="accent-positive-secondary">
                Суперагент
              </Label>
            </div>
          </div>
          <div className={style['agent_description']}>
            Изучаю и анализирую спрос перед&nbsp;продажей, возвращаюсь с&nbsp;несколькими решениями
          </div>
        </div>
        <div className={clsx(style['agent'], style['agent_last'])}>
          <div className={style['agent_image_4']}></div>
          <div className={style['agent_name']}>Михаил</div>
          <div className={style['agent_chips']}>
            <div className={style['agent_chip_experience']}>
              <Label color="decorative-accent-purple" background="decorative-accent-lavender">
                Стаж 10 лет
              </Label>
            </div>
            <div className={style['agent_chip_superagent']}>
              <Label color="accent-positive-primary" background="accent-positive-secondary">
                Суперагент
              </Label>
            </div>
          </div>
          <div className={style['agent_description']}>
            Ваш «риелтор маминой подруги», специализируюсь на дистанционных сделках
          </div>
        </div>
        <div className={style['other_agents']}>
          <div className={style['count_agents']}></div>
          <div className={style['trust_agents']}>надёжных риелторов</div>
        </div>
      </div>
    </div>
  );
};
